<template>
    <div class="form-group">
        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">受理日期</label>
                    <input class="form-control" type="date"
                        :disabled="
                            viewMode==='view' || 
                            (
                                viewMode==='edit' && 
                                modelValue.medical_record_id !== '' && 
                                modelValue.medical_record_id !== null
                            )
                        "
                        v-model="modelValue.accept_date"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">受理單號</label>
                    <input class="form-control" type="text"
                        v-model="modelValue.acknowledgment_serial_no"
                    />
                </div>
            </div>
        </div>

        <div class="row" v-if="showMedicalRecord">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">病歷編號</label>
                    <!-- <label class="form-label"
                        v-if="modelValue.patient_id !== '' && viewMode==='edit'"
                    >病歷編號</label> -->
                    <input v-if="modelValue.medical_record_id != 1 && 
                        modelValue.medical_record_id !== '' && 
                        modelValue.medical_record_id !== null"
                        class="form-control" type="text"
                        :disabled="
                            viewMode==='view' || 
                            (
                                viewMode==='edit' && 
                                modelValue.medical_record_id !== '' && 
                                modelValue.medical_record_id !== null
                            )
                        "
                        v-model="modelValue.medical_serial_no"
                    />
                    <button v-if="modelValue.status_id == 1 && 
                        ( modelValue.medical_record_id == '' || modelValue.medical_record_id == null ) &&
                        $api.users.checkSubPermission('ack','update') &&
                        $api.users.checkPermission('medical')
                        "
                        class="btn btn-primary w-100 mt-2"
                        @click="linkHealthRecordHandle"
                    >
                        查詢晶片/腳環/發報器, 並進行媒合病歷確認
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">物種類型</label>
                    <select class="form-control"
                        :disabled="
                            viewMode==='view' || 
                            (
                                viewMode==='edit' && 
                                modelValue.medical_record_id !== '' && 
                                modelValue.medical_record_id !== null
                            )
                        "
                        v-model="modelValue.species_category_id"
                    >
                        <option :value="-1">請選擇物種類別</option>
                        <option 
                            v-for="(item, key) in speciesTypes" :key="key" :value="item.id"
                        >{{ item.code }}-{{ item.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">物種</label>
                    <selectedDropMenu
                        :disabled="
                            viewMode==='view' || 
                            (
                                viewMode==='edit' && 
                                modelValue.medical_record_id !== '' && 
                                modelValue.medical_record_id !== null
                            )
                        "
                        v-model="modelValue.species_id"
                        :options="getItemSpeciesList"
                    ></selectedDropMenu>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">通報人</label>
                    <input class="form-control me-2" type="text"
                        :disabled="viewMode==='view'"
                        v-model="modelValue.reporter_name"
                    />
                </div>
            </div>
            <div class="col-12 col-xl-6 sub-radio">
                <div class="mb-3 mb-xl-3">
                    <label class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="radios-reporter_type" 
                            :value="1"
                            v-model="modelValue.reporter_type"
                            :disabled="viewMode==='view'" 
                        >
                        <span class="form-check-label"
                        >
                            公部門
                        </span>
                    </label>
                    <label class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="radios-reporter_type" 
                            :value="2"
                            v-model="modelValue.reporter_type"
                            :disabled="viewMode==='view'"
                        >
                        <span class="form-check-label">
                            私人
                        </span>
                    </label>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label found-man">
                        <span>拾獲人</span>
                        <div class="form-check">
                            <input class="form-check-input" 
                                type="checkbox" 
                                :id="`trainee`"
                                v-model="modelValue.same_reporter_tag"
                                :disabled="viewMode==='view'"
                                @change="setFinderValue()"
                            >
                            <label class="form-check-label" :for="`trainee`">
                                同通報人
                            </label>
                        </div>
                    </label>
                    <input class="form-control me-2" type="text"
                        :disabled="viewMode==='view'"
                        v-model="modelValue.finder"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">聯絡方式</label>
                    <input class="form-control me-2" type="text"
                        :disabled="viewMode==='view'"
                        v-model="modelValue.contact"
                    />
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">拾獲日期</label>
                    <div class="address-group">
                        <input class="form-control" type="date"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.find_date"
                        />
                        <input class="form-control" type="time"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.find_time"
                        />
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">拾獲地點</label>
                    <div class="address-group">
                        <select class="form-control"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.find_addr_city"
                            @change="loadArea()"
                        >
                            <option 
                                v-for="(item, key) in citys" :key="key" 
                                :value="item.city"
                            >{{ item.city }}</option>
                        </select>
                        <select class="form-control"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.find_addr_district">
                            <option 
                                v-for="(item, key) in getAreasForCity" :key="key" 
                                :value="item"
                            >{{ item }}</option>
                        </select>
                        <input class="form-control" type="text"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.find_addr_address"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">GPS點位</label>
                    <div class="gps-group">
                        <input class="form-control" type="text" value="test"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.gps_lng"
                        />
                        <input class="form-control" type="text"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.gps_lat"
                        />
                        <i v-if="viewMode == 'create' || viewMode == 'edit'"
                            class="align-middle ms-2 fas fa-fw fa-map-marked-alt"
                            @click="showMapViewHandle"
                        ></i>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-12">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">救援原因</label>
                    <div class="d-flex gap-2">
                        <selectedDropMenu
                            :disabled="(viewMode=='view')"
                            v-model="modelValue.rescure_reason_id"
                            :options="getRescureReasonList"
                            :dir="'top'"
                        ></selectedDropMenu>
                        <input class="form-control" type="text"
                            :disabled="viewMode==='view'"
                            v-model="modelValue.rescure_reason_note"
                        />
                    </div>
                </div>
            </div>
        </div>

        <!-- <div v-if="checkRescureReasonCase"
            class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">動物攻擊種類</label>
                    <select class="form-control"
                        :disabled="viewMode==='view'"
                        v-model="modelValue.attacked_type_id"
                    >
                        <option :value="-1">請選擇動物攻擊種類</option>
                        <option 
                            v-for="(item, key) in animalAttackTypes" :key="key" 
                            :value="item.id"
                            :disabled="!item.isSelect"
                        >{{ item.name }}</option>
                    </select>
                </div>
            </div>
        </div> -->

        <div class="row">
            <div class="col-12 col-xl-6">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">經人為飼養or懷疑</label>
                    <select class="form-control"
                        :disabled="viewMode==='view'"
                        v-model="modelValue.raising_type_id"
                    >
                        <option :value="-1">請選擇經人為飼養or懷疑</option>
                        <option 
                            v-for="(item, key) in feedings" :key="key" 
                            :value="item.id"
                            :disabled="!item.isSelect"
                        >{{ item.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">發現狀況描述</label>
                    <textarea class="form-control" rows="4" placeholder=""
                        :disabled="mode==='view'"
                        v-model="modelValue.description"
                    ></textarea>
                </div>
            </div>
        </div>

        <div v-if="viewMode != 'create'"
            class="row">
            <div class="col-12 col-xl-8">
                <div class="mb-3 mb-xl-3">
                    <label class="form-label">受理單狀態</label>
                    <select class="form-control"
                        :disabled="checkIsSelected"
                        v-model="modelValue.status_id">
                            <option 
                                v-for="(statusItem, key) in statusSelectList" :key="key" 
                                    :value="statusItem.id"
                            >{{ statusItem.name }}</option>
                    </select>
                </div>
            </div>
        </div>

        <!--死亡資訊-->
        
        <!--轉診資訊-->

        <!--轉收容-->

        <linkHealthRecordView
            ref="linkHealthRecordView"
            :species_id="modelValue.species_id"
        ></linkHealthRecordView>

        <mapView
            ref="mapView"
            @selectMapCoordinateHandle="selectMapCoordinate"
        ></mapView>
    </div>
</template>
<script>
import linkHealthRecordView from '@/views/intake/linkHealthRecordView.vue'
import mapView from '@/components/mapView.vue'
import selectedDropMenu from '@/components/selectedDropMenu.vue'
export default {
    name:'intake-forms',
    props:{
        mode: {
            type: String,
            default: 'create'
        },
        type: {
            type: String,
            default: 'inside'
        },
        formStatus:{
            type:Number,
            default:1
        },
        modelValue: {
            type: Object,
            default: {
                id:null, //受理單id
                acknowledgment_serial_no:'', //受理單號
                medical_record_id:null, //病歷id
                medical_serial_no:'', //病歷編號
                species_category_id:-1, //物種類別id
                species_id:-1, //物種id
                reporter_name:'', //通報人
                reporter_type:1, //通報人類型(1:公部門,2:私人)
                same_reporter_tag:false, //同通報人 1:check
                finder:'', //拾獲人
                contact:'', //聯絡方式
                find_date:'',  //拾獲日期
                find_time: '00:00:00',  //拾獲日期
                find_addr_city:'台東縣', //拾獲城市
                find_addr_district:'池上鄉', //拾獲區域
                find_addr_address:'', //拾獲地址
                gps_lng:'', //gps lng
                gps_lat:'', //gps lat
                rescure_reason_id:-1, //救援原因id
                rescure_reason_note:'', //救援原因備註
                attacked_type_id:-1, //動物攻擊種類id
                raising_type_id:-1, //人為原因id
                description:'', //狀況描述
                accept_date:'', //受理日期
                update_time:'', //最近一次更新時間
                status_id:1 //受理單狀態
            }
        }
    },
    data(){
        return {
            intaskType:this.type,
            viewMode:this.mode,
            healthRecord_id:null,
            speciesTypes: [],
            citys: this.$shared.TAIWAN,
            areas: [],
            reacueReason: [],
            animalAttackTypes: [],
            feedings: [],
            statusSelectList:[],
            animals:[]
        }
    },
    components: {
        linkHealthRecordView,mapView,selectedDropMenu
    },
    watch: {
        'modelValue.species_category_id'(to, from) {
            // 当路由变化时调用方法重新加载数据
            this.getAnimals()
        },
        'modelValue.accept_date'(to, from) {
            // 当路由变化时调用方法重新加载数据
            
        },
    },
        
    computed:{
        getRescureReasonList(){
            let itemList = [{value:-1,name:'請選擇救援原因'}]
            for (let index = 0; index < this.reacueReason.length; index++) {
                const item = this.reacueReason[index];
                itemList.push({
                    value: item.id,
                    name: `${item.name}`
                })
            }
            return itemList
        },
        getItemSpeciesList(){
            let itemList = [{value:-1,name:'請選擇物種'}]
            for (let index = 0; index < this.animals.length; index++) {
                const item = this.animals[index];
                itemList.push({
                    value: item.id,
                    name: `${item.name}`
                })
            }
            return itemList
        },
        getAreasForCity(){
            const item = this.citys.find(item=>item.city == this.modelValue.find_addr_city)
            return item ? item.area : []
        },
        
        checkIsSelected(){
            if ( 
                this.viewMode == 'edit' &&
                this.formStatus <= 1
            ){
                return false
            }
            return true
        },
        checkRescureReasonCase(){
            this.$debug(`checkRescureReasonCase`)
            if ( 
                this.reacueReason.length <= 0 ||
                this.animalAttackTypes.length <= 0
            ){
                return false
            }
            const raising = this.reacueReason.find(item=>item.id == this.modelValue.rescure_reason_id )
            const raising_name = raising ? raising.name : ''
            const keyword = "動物攻擊";
            if (raising_name.includes(keyword)) {
                return true
            }
            
            return false
        },
        showMedicalRecord(){
            if ( this.viewMode === 'create' ){
                return false
            }

            if ( this.modelValue.status_id > 92 ){
                if ( this.modelValue.medical_record_id == '' || this.modelValue.medical_record_id == null ){
                    return false
                }
            }

            return true
            
        }
    },
    methods:{
        async initView(statusList=[]){
            
            //取得物種分類清單
            this.$api.species.getSpeciesCategoryByName({
                columeName:'code',
                orderby:'ASC'
            }).then((res)=> {
                if ( res.code !== 200 ){
                    return
                }
                this.speciesTypes = res.data
            });
            this.getParameterOptions()
            
            this.statusSelectList = statusList
        },
        async getAnimals(){      

            this.$debug('getAnimals:',this.modelValue.species_category_id)  
            if ( this.modelValue.species_category_id == -1 ){
                this.animals = []
                return
            }    
            const res = await this.$api.species.getSpeciesByNameAndSpeciesCategoryId({
                species_category_id:this.modelValue.species_category_id
            })
            if ( res.code !== 200 ){
                // //alert(res.msg)
                this.animals = []
                return
            }
            this.animals = res.data
            if ( this.animals.length <= 0 ){
                const species_category = this.speciesTypes.find(item=>item.id == this.modelValue.species_category_id) 
                const species_category_name = species_category ? species_category.name : '未知物種'
                alert(`${species_category_name} 物種類別內沒有建立任何物種，請前往物種管理建立`)
            }
        },
        getParameterOptions(){
            //取得呼叫參數列表取得救援原因
            this.$api.parameters.getParameterOptions().then((res)=>{
                if ( res.code !== 200 ){
                    return
                }
                this.$debug(`res.data:`,res.data)
                //處理救援原因
                this.reacueReason = this.$api.parameters.getSelectOption(1,res.data,this.modelValue.rescure_reason_id)
                //處理動物攻擊 
                this.animalAttackTypes = this.$api.parameters.getSelectOption(2,res.data,this.modelValue.attacked_type_id)
                //處理經人為飼養or懷疑
                this.feedings = this.$api.parameters.getSelectOption(3,res.data,this.modelValue.raising_type_id)
            })
        },
        selectMapCoordinate(data){
            this.modelValue.gps_lat = data.lat
            this.modelValue.gps_lng = data.lng
        },
        linkHealthRecordHandle(is_death=false,death_json=null){
            console.log(`death_json=`,death_json)
            this.$refs.linkHealthRecordView.show(is_death ? death_json : null)
        },
        showMapViewHandle(){
            this.$refs.mapView.show()
        },
        async loadArea(){
            this.modelValue.find_addr_district = this.getAreasForCity[0];
        },
        setFinderValue(){
            if ( this.modelValue.same_reporter_tag ){
                this.modelValue.finder = this.modelValue.reporter_name
            }
        }
    },
    async mounted(){
        
    },
    async created(){
        
    }
};
</script>
<style scoped>
.sub-radio{
    display: flex;
    align-items: flex-end;
    padding-bottom: 0.25rem;
}
.address-group,.gps-group{
    width: 100%;
    display: flex;
    align-items: center;
    gap: .5rem;
}

.address-group > select , 
.address-group > input , 
.gps-group > input {
    flex:1 1;
    
}
.gps-group > i {
    cursor: pointer;
}
.address-group > input {
    flex:3;
    
}
.found-man{
    display: flex;
    gap: 1.25rem;
}
@media (max-width: 768px) {
    .address-group, .gps-group {
        flex-wrap: wrap;
        gap: 1rem;
    }
    .address-group > input {
        flex: 0 auto;
        width: 100%;
    }
}
</style>